import ValidationInterface from '@/plans/common/validation-interface';
import { zcmCategories } from '@/common/persist-cart/categories';

export default class extends ValidationInterface {
  async requires() {
    return [this.current(zcmCategories).require('ZCM')];
  }

  async conflicts() {
    return zcmCategories;
  }
}
